import React, { useState } from "react";
import MultiSelector from "../../../../components/atoms/Selector/MultiSelector";
import { useSettingsContext } from "../SettingsContext";
import FloatingInputText from "../../../../components/form/FloatingInputText";

const CompanyDetails = ({ handleBusinessTypeUpdate }) => {
  const [name, setName] = useState("");
  const { setCompanyName, setBusinessType } = useSettingsContext();

  const businessTypes = [
    {
      label: "Enterprise Business",
      value: 1,
    },
    {
      label: "Single Business",
      value: 2,
    },
  ];

  const recordCompanyName = (e) => {
    setName(e.target.value);
    setCompanyName({ companyId: 1, companyName: e.target.value });
  };

  const handleBusinessSelection = (businessId, businessName) => {
    handleBusinessTypeUpdate(businessId);
    setBusinessType({ businessId: businessId, businessName: businessName });
  };

  return (
    <div>
      <h2 className={"uppercase text-2xl font-bold"}>Business details</h2>
      <hr className="h-px my-8 bg-gray-200 border-0" />
      <div className="grid gap-6 mb-6 md:grid-cols-1 lg:w-1/2">
        <FloatingInputText
          className="my-3 transition-all"
          name="name"
          label="Company name"
          type="text"
          value={name}
          placeholder="Enter company name"
          error={null}
          onChange={recordCompanyName}
        />
      </div>
      <div className="grid gap-6 mb-6 md:grid-cols-1 lg:w-1/2">
        <MultiSelector
          placeholder="Choose business type"
          dropDownData={businessTypes}
          callBackHandler={handleBusinessSelection}
        />
      </div>
    </div>
  );
};

export default CompanyDetails;
